var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 51,
    viewBox: "0 0 55 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0105591,
    width: 54.9844,
    height: 51,
    rx: 6,
    fill: "#FC7100"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3034 25.2929C11.9129 25.6834 11.9129 26.3166 12.3034 26.7071L18.6674 33.0711C19.0579 33.4616 19.6911 33.4616 20.0816 33.0711C20.4721 32.6805 20.4721 32.0474 20.0816 31.6569L14.4248 26L20.0816 20.3431C20.4721 19.9526 20.4721 19.3195 20.0816 18.9289C19.6911 18.5384 19.0579 18.5384 18.6674 18.9289L12.3034 25.2929ZM40.0106 25L13.0106 25V27L40.0106 27V25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.b5bf3aa1980871f165fe401fb776fce4.svg";
export { ForwardRef as ReactComponent };